module.exports = __webpack_public_path__ + "static/media/logo.1bb70ce6.png";